import AOS from 'aos';
import vars from '../helpers';

function refresh() {
	$('.aos-animate').removeClass('aos-animate');
}

export function aosInit() {
	if (!vars.isMobile()) {
		$('.page__image').removeAttr('data-aos')
	}
	if (vars.isMobile()) {
		$('.intro__description').attr('data-aos-delay', 1200)
	}

	AOS.init({
		once: true,
	});
}
